export default "__VITE_ASSET__ea8d9083__"